<template>

<core-filter-input-text v-on:ready="onReady" :filter="filter" placeholder="Quick search..." class="filter-text" />

</template>

<script>

export default {

	props: [
		'filter'
	],

	data: function() {

		return {
			el: false
		}

	},

	created: function() {

		window.addEventListener('keydown', this.onShortcut.bind(this))

	},

	beforeDestroy: function() {

		window.removeEventListener('keydown', this.onShortcut.bind(this))

	},

	methods: {

		onShortcut: function(e) {

			if (e.ctrlKey && e.keyCode === 70) {

				e.preventDefault()
				this.el.focus()

			}

		},

		onReady: function(el) {

			this.el = el

		}

	}

}

</script>

<style scoped>

.filter-text  {
	padding: 0px!important;
}

.is-mobile .filter-text {
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
}

.filter-text >>> input {
	background-color: #fff!important;
	color: #343434!important;
	font-size: 14px!important;
	padding: 0px 10px!important;
	height: 40px!important;
	border-radius: 4px!important;
	box-shadow: rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}

.is-mobile .filter-text >>> input {
	border-radius: 0px!important;
}

.filter-text >>> input::placeholder {
	color: #999!important;
	font-style: normal!important;
}

</style>
